import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInfoCircle } from '@fortawesome/pro-solid-svg-icons/faInfoCircle';
import React from 'react';

import classnames from 'clsx';
import PropTypes from 'prop-types';
import { defineMessages, FormattedMessage } from 'react-intl';

import { Tooltip } from 'ui-components/components/tooltip';
import { TooltipContent } from 'ui-components/components/tooltip/tooltip-content';

import style from './pickup-relay-tooltip.module.css';

const messages = defineMessages({
  headerTooltipText: {
    defaultMessage: 'This order will be shipped to a specified location for recipient pickup.',
    id: 'xcw82X',
    description: 'Shipping service pickup relay tooltip text',
  },
  shippingTooltipText: {
    defaultMessage:
      'This order is shipping to a pickup location. The services available are based on the carrier information sent by the marketplace.',
    id: 'G9FHsG',
    description: 'Shipping service pickup relay tooltip text',
  },
});

const onclick = (e) => e.stopPropagation();

export const PickupRelayTooltip = ({ isShippingServiceInstance = false, iconClassName, tooltipTargetWrapperClassName }) => {
  const messageToDisplay = isShippingServiceInstance ? messages.shippingTooltipText : messages.headerTooltipText;

  const tooltipBodyContent = (
    <div className={style['tooltip-content']} onClick={onclick}>
      <FormattedMessage {...messageToDisplay} />
    </div>
  );

  return (
    <Tooltip>
      <div className={tooltipTargetWrapperClassName}>
        <FontAwesomeIcon className={classnames(style.icon, iconClassName)} icon={faInfoCircle} />
      </div>
      <TooltipContent>{tooltipBodyContent}</TooltipContent>
    </Tooltip>
  );
};

PickupRelayTooltip.propTypes = {
  isShippingServiceInstance: PropTypes.bool,
  iconClassName: PropTypes.string,
  tooltipTargetWrapperClassName: PropTypes.string,
};
